module.exports = __webpack_public_path__ + "static/media/mini_spidey.ada85c8f.png";